import { FacetProfileField } from '../../core/profiles/entities/profile-field.entity';
import { ShFacet, ShSelectableFacetValue } from '../../elements/components/facet/entities/facet.entity';
import { Facet } from '../entities/facet.entity';

export function FacetsResponseToShFacets(facets: Facet[], facetProfileFields: FacetProfileField[]): ShFacet[] {
    return facetProfileFields
        .map(facetProfileField => MapFacetToShFacet(facets, facetProfileField))
        .filter((facet): facet is ShFacet => facet !== null);
}

function MapFacetToShFacet(facets: Facet[], facetProfileField: FacetProfileField): ShFacet | null {
    const profileFacet: Facet | undefined = facets.find(facet => facet.DottedKey === facetProfileField.DottedKey);

    if (!profileFacet) {
        return null;
    }

    return {
        key: facetProfileField.DottedKey,
        label: facetProfileField.DisplayLabel,
        hasMoreValues: profileFacet.HasMoreValues,
        values: profileFacet ? MapValuesToShFacetValue(profileFacet, facetProfileField) : [],
        selectionType: facetProfileField.SelectionType
    };
}

function MapValuesToShFacetValue(facet: Facet, facetProfileField: FacetProfileField): ShSelectableFacetValue[] {
    return facet.Values.map(value => {
        return {
            value: value.Value,
            label: value.Value,
            selectionType: facetProfileField.SelectionType,
            count: value.Count,
            missing: value.Missing,
            selected: false
        };
    });
}
